import React, { useContext } from 'react';

// import PropTypes from 'prop-types';
import ButtonPrimaryEllipse from '../ButtonPrimaryEllipse';
import GradientBlurb from '../GradientBlurb';
import PhotoCred from '../PhotoCred';
import s from './CardGlassLink.module.scss';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import { BackgroundContext } from '../../containers/BasePage';
import useIntersectionObserver from '../../hooks/useIntersectionObserver';
import { trackReadMore } from '../../utils/dataLayer';
import classNames from 'classnames';
import getFocalImageStyles from '../../utils/getFocalImageStyles';

const CardGlassLink = ({
  image = {},
  title,
  text,
  href = {},
  reverse = false,
  backgroundColor = 'black',
  fromPage,
  componentModifiers = [],
  nextColor,
  nextItemSameAsCurrent = false,
}) => {
  const [ref, isVisible] = useIntersectionObserver(0, '', true);

  const background = useContext(BackgroundContext) || false;

  let bgColor = backgroundColor;
  if (background?.hasSetBg) {
    bgColor = background?.whiteBackground ? 'white' : 'black';
  }

  const sameBackground = nextColor === bgColor;

  const componentHasNoImage = !image?.url;
  const classes = classNames(
    s.Root,
    s[fromPage],
    componentModifiers.map((m) => s[m]),
    {
      [s.NoImage]: componentHasNoImage,
      [s.Reverse]: reverse,
      [s.Visible]: isVisible,
      [s.White]: bgColor === 'white',
      [s.Black]: bgColor === 'black',
      [s.SameBackground]: sameBackground,
      [s.NextItemSameAsCurrent]: nextItemSameAsCurrent,
    }
  );

  const cardContentClasses = classNames(s.CardContent, {
    'black-glass': bgColor === 'black',
    'white-glass': bgColor === 'white',
  });
  const { t } = useTranslation();

  const isExternal = href?.isExternal || false;

  const imageStyle = getFocalImageStyles(image);

  const handleTrackReadMore = (e) => {
    e.preventDefault();

    trackReadMore(title, 'Card glass link');

    setTimeout(() => {
      window.location.href = href?.href;
    }, 200);
  };
  const sizes =
    '(min-width: 1440px) 782px, (min-width: 1280px) 600px, (min-width: 1024px) 920px, (min-width: 768px) 720px, 100vw';

  return (
    <section className={classes} ref={ref}>
      <div className={`${s.Wrap}`}>
        {!!image.url && (
          <div className={s.ImageContainer}>
            {backgroundColor === 'black' && (
              <GradientBlurb modifiers={['HomePage']} />
            )}
            <Image
              className={s.Image}
              src={image?.url}
              alt=""
              fill
              style={imageStyle}
              quality={75}
              sizes={sizes}
            />
            <PhotoCred
              credit={image?.credit}
              modifiers={['MobileLeft', 'MobileOnly']}
            />
          </div>
        )}
        {!!image.url && (
          <div className={reverse ? s.PhotoCredWrapReverse : undefined}>
            <PhotoCred
              credit={image?.credit}
              modifiers={
                bgColor === 'white' ? ['Black', 'DesktopOnly'] : ['DesktopOnly']
              }
            />
          </div>
        )}
        <div className={cardContentClasses}>
          <div className={s.Content}>
            <h2 className={s.Heading}>{title}</h2>
            <div className={s.Text}>{text}</div>
          </div>
          {!!href.href && (
            <div className={s.Button}>
              <ButtonPrimaryEllipse
                animateIcon
                fromPage={fromPage}
                asLink
                hideStroke={bgColor === 'white'}
                href={href.href}
                onColor={bgColor}
                onClick={handleTrackReadMore}
                modifiers={
                  componentHasNoImage
                    ? ['ShowTextMobile', `${backgroundColor}`]
                    : [`${backgroundColor}`]
                }
                icon={
                  isExternal ? 'icon-external-white' : 'icon-arrow-right-white'
                }
                iconDimensions={isExternal ? [18, 18] : [20, 20]}>
                {!!href.text ? href.text : t('Common.readMore')}
                <span className="sr-only"> {title}</span>
              </ButtonPrimaryEllipse>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

CardGlassLink.propTypes = {};

CardGlassLink.defaultProps = {};

export default CardGlassLink;
